export let Newsroom;
(function (_Newsroom) {
  let Status = /*#__PURE__*/function (Status) {
    Status["ACTIVE"] = "active";
    Status["INACTIVE"] = "inactive";
    Status["ARCHIVED"] = "archived";
    return Status;
  }({});
  _Newsroom.Status = Status;
  let EmailBrandingMode = /*#__PURE__*/function (EmailBrandingMode) {
    EmailBrandingMode["DEFAULT"] = "default";
    EmailBrandingMode["CUSTOM"] = "custom";
    return EmailBrandingMode;
  }({});
  _Newsroom.EmailBrandingMode = EmailBrandingMode;
  let TrackingPolicy = /*#__PURE__*/function (TrackingPolicy) {
    TrackingPolicy["DEFAULT"] = "default";
    TrackingPolicy["DISABLED"] = "disabled";
    TrackingPolicy["CONSENT_TO_IDENTIFY"] = "consent-to-identify";
    TrackingPolicy["STRICT"] = "strict";
    TrackingPolicy["NORMAL"] = "normal";
    TrackingPolicy["LENIENT"] = "lenient";
    return TrackingPolicy;
  }({});
  _Newsroom.TrackingPolicy = TrackingPolicy;
  let EmailLogoAlignment = /*#__PURE__*/function (EmailLogoAlignment) {
    EmailLogoAlignment["LEFT"] = "left";
    EmailLogoAlignment["CENTER"] = "center";
    EmailLogoAlignment["RIGHT"] = "right";
    return EmailLogoAlignment;
  }({});
  _Newsroom.EmailLogoAlignment = EmailLogoAlignment;
  /*
   * Status checks
   */
  function isActive(arg) {
    if (typeof arg === 'object' && arg !== null) {
      return isActive(arg.status);
    }
    return arg === Status.ACTIVE;
  }
  _Newsroom.isActive = isActive;
  function isInactive(arg) {
    if (typeof arg === 'object' && arg !== null) {
      return isInactive(arg.status);
    }
    return arg === Status.INACTIVE;
  }
  _Newsroom.isInactive = isInactive;
  function isArchived(arg) {
    if (typeof arg === 'object' && arg !== null) {
      return isArchived(arg.status);
    }
    return arg === Status.ARCHIVED;
  }
  _Newsroom.isArchived = isArchived;
})(Newsroom || (Newsroom = {}));